import { Stack } from '@mui/material';
import AssetLogo from 'sections/AssetLogo';

const PlatformCompanyLogo = ({ integration, size, mt = 0.5, ...props }: any) => {
  return (
    <Stack direction={'row'} spacing={-1.5} mt={mt} {...props}>
      <AssetLogo logo={integration?.logo} name={integration?.name} size={size ? size : 'sm'} isPublic={true}/>
      <AssetLogo logo={integration?.company?.logo} name={integration?.company?.legalName || 'UNKNOWN'} size={size ? size : 'sm'} />
    </Stack>
  );
};

export default PlatformCompanyLogo;